module.exports = __webpack_public_path__ + "static/media/Lectures_and_Panels.eebc0af0.md";